import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/default.css";
import "../styles/market.css";
import "../styles/responsive.css";
import "../styles/tailwind-bridge.css";
import "../styles/home.css";
import Footer from "./common/Footer.jsx";
import Navbar from "./common/Navbar.jsx";

function Home() {
  useEffect(() => {
    // Scroll animation for reveal effects
    const handleScroll = () => {
      const elements = document.querySelectorAll(".scroll-reveal");
      elements.forEach((element) => {
        const windowHeight = window.innerHeight;
        const elementTop = element.getBoundingClientRect().top;
        const showPoint = 150;

        if (elementTop < windowHeight - showPoint) {
          element.classList.add("animate-slide-up");
          element.classList.remove("opacity-0");
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const TypingText = () => {
    const lines = [
      "We Build your business,",
      "We build Africa,",
      "Africa my Business.",
    ];
    const [displayText, setDisplayText] = useState(["", "", ""]);
    const [currentLine, setCurrentLine] = useState(0);
    const [currentChar, setCurrentChar] = useState(0);

    useEffect(() => {
      if (currentLine >= lines.length) return;

      if (currentChar < lines[currentLine].length) {
        const timer = setTimeout(() => {
          setDisplayText((prev) => {
            const newText = [...prev];
            newText[currentLine] = lines[currentLine].substring(
              0,
              currentChar + 1
            );
            return newText;
          });
          setCurrentChar((prev) => prev + 1);
        }, 30); // Adjust speed here (lower = faster)

        return () => clearTimeout(timer);
      } else {
        // Move to next line after a pause
        const timer = setTimeout(() => {
          setCurrentLine((prev) => prev + 1);
          setCurrentChar(0);
        }, 500); // Pause between lines

        return () => clearTimeout(timer);
      }
    }, [currentLine, currentChar]);
    return (
      <section className="relative h-[300px] md:h-[500px] overflow-hidden rounded-2xl mx-2">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src="images/market.jpg"
            alt="IBloTec Market"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#3c3f8c]/80 via-[#00a6d8]/50 to-[#3c3f8c]/90"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-[#000000]/50 to-[#000000]/50"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 h-full flex items-center justify-start px-2 md:px-12">
          <div className="text-white">
            <div className="text-4xl md:text-7xl font-bold leading-tight">
              {displayText.map((line, index) => (
                <React.Fragment key={index}>
                  <span className="block text-white">{line}</span>
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  };

  const ProductSlider = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
      const fetchProducts = async () => {
        try {
          const response = await fetch(
            `${import.meta.env.VITE_API_URL}/api/products`
          );
          if (!response.ok) throw new Error("Failed to fetch products");
          const data = await response.json();
          setProducts(data.slice(0, 10));
          setLoading(false);
        } catch (err) {
          setError(err.message);
          setLoading(false);
        }
      };
      fetchProducts();
    }, []);

    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) =>
          prevIndex >= products.length - 3 ? 0 : prevIndex + 1
        );
      }, 3000);
      return () => clearInterval(interval);
    }, [products.length]);

    if (loading) {
      return (
        <section className="py-24 bg-gradient-to-br from-[#3c3f8c] to-[#00a6d8] relative overflow-hidden">
          {/* Background Image */}
          <div className="absolute inset-0 opacity-20">
            <img
              src="images/market1.jpg"
              alt="Background"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="container-iblotec text-center relative z-10">
            <div className="inline-flex items-center space-x-2 bg-[#00a6d8] text-white px-6 py-2 rounded-full text-sm font-semibold mb-6">
              <i className="fa-solid fa-shopping-bag"></i>
              <span>Featured Products</span>
            </div>
            <div className="flex flex-col items-center space-y-4">
              <div className="relative">
                <div className="w-16 h-16 border-4 border-[#00a6d8]/30 border-t-[#00a6d8] rounded-full animate-spin"></div>
                <div
                  className="absolute inset-0 w-16 h-16 border-4 border-transparent border-t-white rounded-full animate-spin"
                  style={{
                    animationDirection: "reverse",
                    animationDuration: "1.5s",
                  }}
                ></div>
              </div>
              <p className="text-xl text-white">Loading amazing products...</p>
            </div>
          </div>
        </section>
      );
    }

    if (error) {
      return (
        <section className="py-24 bg-gradient-to-br from-[#3c3f8c] to-[#00a6d8] relative overflow-hidden">
          {/* Background Image */}
          <div className="absolute inset-0 opacity-20">
            <img
              src="images/market.jpg"
              alt="Background"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="container-iblotec text-center relative z-10">
            <div className="bg-[#3c3f8c]/20 border border-white/20 rounded-3xl p-12 max-w-md mx-auto backdrop-blur-sm">
              {/* <i className="fa-solid fa-exclamation-triangle text-4xl text-white mb-4"></i> */}
              {/* <i className="fa-solid fa-shopping-cart group-hover:bounce text-4xl text-white mb-4"></i> */}
              {/* <p className="text-xl text-white">Connection Error!</p> 
              <p className="text-white/80 mt-2">
                Unable to load products at the moment.
              </p>
              //////////////////
              <p className="text-xl text-white">THE MARKET IS NOT AVAILABLE!</p>
              <p className="text-white/80 mt-2">We're updating the System</p>*/}
              <Link
                to="https://iblotecmarket.com/vendor/auth/registration/index"
                className="border-2 border-white text-white px-10 py-4 rounded-full font-bold text-lg bg-white/70 backdrop-blur-sm hover:bg-white transition-all duration-300 flex items-center justify-center space-x-3 hover:scale-105 hover:shadow-2xl"
              >
                <span className="text-[#00a6d8]">START SHOPPING NOW</span>
                <i className="fa-solid fa-shopping-cart text-[#00a6d8]"></i>
              </Link>
            </div>
          </div>
        </section>
      );
    }

    const visibleProducts = products.slice(currentIndex, currentIndex + 3);

    return (
      <section className="py-24 bg-gradient-to-br from-[#3c3f8c] to-[#00a6d8] text-white relative overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 opacity-30">
          <img
            src="images/market.jpg"
            alt="Background"
            className="w-full h-full object-cover"
          />
        </div>
        {/* Background Effects */}
        <div className="absolute inset-0">
          <div className="absolute top-20 left-20 w-64 h-64 bg-[#00a6d8]/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-20 w-80 h-80 bg-white/10 rounded-full blur-3xl"></div>
        </div>

        <div className="container-iblotec relative z-10">
          <div className="text-center mb-16">
            <div className="inline-flex items-center space-x-2 bg-[#00a6d8] text-white px-6 py-2 rounded-full text-sm font-semibold mb-6">
              <i className="fa-solid fa-shopping-bag"></i>
              <span>Featured Products</span>
            </div>
            <h2 className="text-5xl md:text-6xl font-black mb-6">
              <span className="bg-gradient-to-r from-[#00a6d8] to-white bg-clip-text text-transparent">
                Trending Now
              </span>
            </h2>
            <p className="text-xl text-white max-w-2xl mx-auto">
              Discover the most popular products from African entrepreneurs
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {visibleProducts.map((product, index) => (
              <div key={product.id} className="group">
                <div className="relative overflow-hidden rounded-3xl bg-white/10 backdrop-blur-lg border border-white/20 hover:bg-white/20 transition-all duration-500 hover:scale-105">
                  <div className="aspect-square overflow-hidden">
                    <img
                      src={`${import.meta.env.VITE_API_URL}/${product.image1}`}
                      alt={product.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                      onError={(e) => {
                        e.target.src = "images/placeholder.jpg";
                      }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <div className="absolute top-4 right-4">
                      <div className="w-8 h-8 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                        <i className="fa-solid fa-heart text-white text-sm"></i>
                      </div>
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="font-bold text-xl mb-2 text-white group-hover:text-[#00a6d8] transition-colors">
                      {product.name}
                    </h3>
                    <div className="flex items-center justify-between">
                      <p className="text-2xl font-bold text-[#00a6d8]">
                        {product.price} Fbu
                      </p>
                      <button className="bg-[#00a6d8] hover:bg-[#3c3f8c] text-white px-4 py-2 rounded-full text-sm font-semibold hover:scale-105 transition-all duration-300">
                        <i className="fa-solid fa-shopping-cart mr-1"></i>
                        Add to Cart
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Product Navigation */}
          <div className="flex justify-center items-center space-x-4">
            <button
              onClick={() => setCurrentIndex(Math.max(0, currentIndex - 1))}
              className="w-12 h-12 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full flex items-center justify-center text-white hover:bg-white/20 transition-all duration-300 disabled:opacity-50"
              disabled={currentIndex === 0}
            >
              <i className="fa-solid fa-chevron-left"></i>
            </button>

            <div className="flex space-x-2">
              {Array.from(
                { length: Math.ceil(products.length / 3) },
                (_, i) => (
                  <button
                    key={i}
                    onClick={() => setCurrentIndex(i * 3)}
                    className={`w-3 h-3 rounded-full transition-all duration-300 ${
                      Math.floor(currentIndex / 3) === i
                        ? "bg-[#00a6d8] w-8"
                        : "bg-white/30 hover:bg-white/50"
                    }`}
                  ></button>
                )
              )}
            </div>

            <button
              onClick={() =>
                setCurrentIndex(Math.min(products.length - 3, currentIndex + 1))
              }
              className="w-12 h-12 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full flex items-center justify-center text-white hover:bg-white/20 transition-all duration-300 disabled:opacity-50"
              disabled={currentIndex >= products.length - 3}
            >
              <i className="fa-solid fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </section>
    );
  };

  const AchievementsShowcase = () => {
    const [counts, setCounts] = useState({
      sellers: 0,
      trained: 0,
      agents: 0,
      users: 0,
    });

    useEffect(() => {
      // Animated counters
      const targets = {
        sellers: 200,
        trained: 5000,
        agents: 120,
        users: 10000,
      };

      const duration = 2000;
      const steps = 50;
      const increments = {
        sellers: targets.sellers / steps,
        trained: targets.trained / steps,
        agents: targets.agents / steps,
        users: targets.users / steps,
      };

      let currentStep = 0;
      const timer = setInterval(() => {
        if (currentStep < steps) {
          setCounts({
            sellers: Math.min(
              Math.floor(increments.sellers * (currentStep + 1)),
              targets.sellers
            ),
            trained: Math.min(
              Math.floor(increments.trained * (currentStep + 1)),
              targets.trained
            ),
            agents: Math.min(
              Math.floor(increments.agents * (currentStep + 1)),
              targets.agents
            ),
            users: Math.min(
              Math.floor(increments.users * (currentStep + 1)),
              targets.users
            ),
          });
          currentStep++;
        } else {
          clearInterval(timer);
        }
      }, duration / steps);

      return () => clearInterval(timer);
    }, []);

    return (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
        <div className="relative group">
          <div className="absolute inset-0 bg-gradient-to-r from-amber-400 to-orange-500 rounded-2xl blur-lg opacity-0 group-hover:opacity-50 transition-opacity duration-500"></div>
          <div className="relative bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-xl border border-amber-200/50 hover:scale-105 transition-all duration-500">
            <div className="w-12 h-12 bg-gradient-to-br from-amber-400 to-orange-500 rounded-xl flex items-center justify-center mb-4 mx-auto group-hover:rotate-12 transition-transform">
              <i className="fa-solid fa-store text-white text-xl"></i>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-amber-600 to-orange-600 bg-clip-text text-transparent">
                {counts.sellers}+
              </div>
              <div className="text-sm text-gray-600 font-semibold mt-1">
                Active Sellers
              </div>
              <div className="text-xs text-gray-500 mt-1">Across Africa</div>
            </div>
          </div>
        </div>

        <div className="relative group">
          <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-teal-500 rounded-2xl blur-lg opacity-0 group-hover:opacity-50 transition-opacity duration-500"></div>
          <div className="relative bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-xl border border-emerald-200/50 hover:scale-105 transition-all duration-500">
            <div className="w-12 h-12 bg-gradient-to-br from-emerald-400 to-teal-500 rounded-xl flex items-center justify-center mb-4 mx-auto group-hover:rotate-12 transition-transform">
              <i className="fa-solid fa-graduation-cap text-white text-xl"></i>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">
                {counts.trained}+
              </div>
              <div className="text-sm text-gray-600 font-semibold mt-1">
                Youth Trained
              </div>
              <div className="text-xs text-gray-500 mt-1">IBloTec Academy</div>
            </div>
          </div>
        </div>

        <div className="relative group">
          <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-indigo-500 rounded-2xl blur-lg opacity-0 group-hover:opacity-50 transition-opacity duration-500"></div>
          <div className="relative bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-xl border border-blue-200/50 hover:scale-105 transition-all duration-500">
            <div className="w-12 h-12 bg-gradient-to-br from-blue-400 to-indigo-500 rounded-xl flex items-center justify-center mb-4 mx-auto group-hover:rotate-12 transition-transform">
              <i className="fa-solid fa-users text-white text-xl"></i>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                {counts.agents}+
              </div>
              <div className="text-sm text-gray-600 font-semibold mt-1">
                Agents Network
              </div>
              <div className="text-xs text-gray-500 mt-1">All Communes</div>
            </div>
          </div>
        </div>

        <div className="relative group">
          <div className="absolute inset-0 bg-gradient-to-r from-purple-400 to-pink-500 rounded-2xl blur-lg opacity-0 group-hover:opacity-50 transition-opacity duration-500"></div>
          <div className="relative bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-xl border border-purple-200/50 hover:scale-105 transition-all duration-500">
            <div className="w-12 h-12 bg-gradient-to-br from-purple-400 to-pink-500 rounded-xl flex items-center justify-center mb-4 mx-auto group-hover:rotate-12 transition-transform">
              <i className="fa-solid fa-globe text-white text-xl"></i>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
                {counts.users}K+
              </div>
              <div className="text-sm text-gray-600 font-semibold mt-1">
                Global Users
              </div>
              <div className="text-xs text-gray-500 mt-1">And Growing</div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const EcosystemSection = () => {
    return (
      <section className="py-24 bg-gradient-to-br from-white via-indigo-50 to-blue-50 scroll-reveal opacity-0 relative overflow-hidden">
        {/* Animated background patterns */}
        <div className="absolute inset-0">
          <div className="absolute top-20 left-10 w-72 h-72 bg-[#00a6d8]/5 rounded-full blur-3xl animate-float"></div>
          <div
            className="absolute bottom-20 right-10 w-96 h-96 bg-[#3c3f8c]/5 rounded-full blur-3xl animate-float"
            style={{ animationDelay: "2s" }}
          ></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-to-r from-[#00a6d8]/5 to-[#3c3f8c]/5 rounded-full blur-3xl animate-pulse-slow"></div>
        </div>

        <div className="container-iblotec relative z-10">
          <div className="text-center mb-16">
            <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-[#00a6d8] to-[#3c3f8c] text-white px-6 py-2 rounded-full text-sm font-semibold mb-6 animate-bounce-subtle">
              <i className="fa-solid fa-crown text-white"></i>
              <span className="text-white">The IBloTec Ecosystem</span>
            </div>
            <h2 className="text-4xl md:text-6xl font-black mb-6">
              <span className="bg-gradient-to-r from-[#3c3f8c] via-[#00a6d8] to-[#3c3f8c] bg-clip-text text-transparent">
                By Africans, For Africans,
              </span>
              <br />
              <span className="text-[#00a6d8]">Serving the World</span>
            </h2>
            <p className="text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
              A visionary tech company designed to connect people, products, and
              innovation — uniting African cultures, traditions, and
              technologies across the continent and diaspora.
            </p>
          </div>

          {/* Ecosystem Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
            {/* Commerce Infrastructure */}
            <div className="group relative">
              <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-teal-500 rounded-3xl blur-xl opacity-0 group-hover:opacity-30 transition-opacity duration-500"></div>
              <div className="relative bg-white rounded-3xl p-8 shadow-2xl border border-emerald-100 hover:border-emerald-300 transition-all duration-500 hover:scale-105">
                <div className="absolute -top-4 -right-4 w-16 h-16 bg-emerald-500 rounded-full flex items-center justify-center animate-pulse">
                  <i className="fa-solid fa-store text-white text-2xl"></i>
                </div>
                <div className="w-20 h-20 bg-gradient-to-br from-emerald-400 to-teal-500 rounded-2xl flex items-center justify-center mb-6 group-hover:rotate-12 transition-transform">
                  <i className="fa-solid fa-cart-shopping text-white text-3xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-[#3c3f8c] mb-4">
                  IBloTec Market
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  <span className="font-bold text-emerald-600">
                    AfroMarket:
                  </span>{" "}
                  Empowering local businesses, potentials, and talents to export
                  African ideas to the world.
                </p>
                <div className="space-y-2">
                  <div className="flex items-center text-sm text-gray-600">
                    <i className="fa-solid fa-check-circle text-emerald-500 mr-2"></i>
                    <span>Empower small businesses</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-600">
                    <i className="fa-solid fa-check-circle text-emerald-500 mr-2"></i>
                    <span>Promote AfroCommerce</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-600">
                    <i className="fa-solid fa-check-circle text-emerald-500 mr-2"></i>
                    <span>Celebrate African cultures & traditions</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-600">
                    <i className="fa-solid fa-check-circle text-emerald-500 mr-2"></i>
                    <span>Made in Burundi → Made for the World</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Fintech Ecosystem */}
            <div className="group relative">
              <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-indigo-500 rounded-3xl blur-xl opacity-0 group-hover:opacity-30 transition-opacity duration-500"></div>
              <div className="relative bg-white rounded-3xl p-8 shadow-2xl border border-blue-100 hover:border-blue-300 transition-all duration-500 hover:scale-105">
                <div
                  className="absolute -top-4 -right-4 w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center animate-pulse"
                  style={{ animationDelay: "1s" }}
                >
                  <i className="fa-solid fa-bolt text-white text-2xl"></i>
                </div>
                <div className="w-20 h-20 bg-gradient-to-br from-blue-400 to-indigo-500 rounded-2xl flex items-center justify-center mb-6 group-hover:rotate-12 transition-transform">
                  <i className="fa-solid fa-coins text-white text-3xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-[#3c3f8c] mb-4">
                  IBloCash & IBloPay
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  Revolutionary fintech solutions that empower people and
                  strengthen financial systems across Africa.
                </p>
                <div className="grid grid-cols-2 gap-2 text-sm">
                  <div className="flex items-center text-gray-600">
                    <i className="fa-solid fa-wallet text-blue-500 mr-1"></i>
                    <span>Digital Wallet</span>
                  </div>
                  <div className="flex items-center text-gray-600">
                    <i className="fa-solid fa-mobile-alt text-blue-500 mr-1"></i>
                    <span>Mobile Payments</span>
                  </div>
                  <div className="flex items-center text-gray-600">
                    <i className="fa-solid fa-building-columns text-blue-500 mr-1"></i>
                    <span>Bank Integration</span>
                  </div>
                  <div className="flex items-center text-gray-600">
                    <i className="fa-solid fa-globe text-blue-500 mr-1"></i>
                    <span>International</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Social & Innovation */}
            <div className="group relative">
              <div className="absolute inset-0 bg-gradient-to-r from-purple-400 to-pink-500 rounded-3xl blur-xl opacity-0 group-hover:opacity-30 transition-opacity duration-500"></div>
              <div className="relative bg-white rounded-3xl p-8 shadow-2xl border border-purple-100 hover:border-purple-300 transition-all duration-500 hover:scale-105">
                <div
                  className="absolute -top-4 -right-4 w-16 h-16 bg-purple-500 rounded-full flex items-center justify-center animate-pulse"
                  style={{ animationDelay: "2s" }}
                >
                  <i className="fa-solid fa-comments text-white text-2xl"></i>
                </div>
                <div className="w-20 h-20 bg-gradient-to-br from-purple-400 to-pink-500 rounded-2xl flex items-center justify-center mb-6 group-hover:rotate-12 transition-transform">
                  <i className="fa-solid fa-message text-white text-3xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-[#3c3f8c] mb-4">
                  IBloChat & Innovation
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  Social communication and creative tools that tell real African
                  stories and preserve our heritage.
                </p>
                <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl p-4">
                  <p className="text-sm text-gray-700 italic">
                    "Innovating products that serve people, from communication
                    to civilization — telling Burundi's real stories to the
                    world."
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Academy Section */}
          <div className="relative group">
            <div className="absolute inset-0 bg-gradient-to-r from-amber-400 to-orange-500 rounded-3xl blur-xl opacity-20 group-hover:opacity-40 transition-opacity duration-500"></div>
            <div className="relative bg-white rounded-3xl p-10 shadow-2xl border border-amber-200 overflow-hidden">
              <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-amber-400/10 to-orange-500/10 rounded-full -mr-20 -mt-20"></div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
                <div>
                  <div className="w-16 h-16 bg-gradient-to-br from-amber-400 to-orange-500 rounded-2xl flex items-center justify-center mb-6 group-hover:rotate-12 transition-transform">
                    <i className="fa-solid fa-graduation-cap text-white text-2xl"></i>
                  </div>
                  <h3 className="text-3xl font-bold text-[#3c3f8c] mb-4">
                    IBloTec Academy
                  </h3>
                  <p className="text-gray-700 text-lg mb-6 leading-relaxed">
                    Empowering thousands of young Africans to discover their
                    potential, teaching the new world economy in a practical
                    way, and creating job opportunities through digital skills
                    and innovation.
                  </p>
                  <div className="flex items-center space-x-4">
                    <div className="flex -space-x-2">
                      {[1, 2, 3, 4].map((i) => (
                        <div
                          key={i}
                          className="w-10 h-10 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full border-2 border-white flex items-center justify-center"
                        >
                          <i className="fa-solid fa-user text-white text-xs"></i>
                        </div>
                      ))}
                    </div>
                    <span className="text-sm text-gray-600">
                      +5,000 graduates
                    </span>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-4 text-center">
                    <div className="text-3xl font-bold text-amber-600 mb-1">
                      40+
                    </div>
                    <div className="text-xs text-gray-600">Communities</div>
                  </div>
                  <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-xl p-4 text-center">
                    <div className="text-3xl font-bold text-orange-600 mb-1">
                      100%
                    </div>
                    <div className="text-xs text-gray-600">
                      Practical Training
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-yellow-50 to-amber-50 rounded-xl p-4 text-center">
                    <div className="text-3xl font-bold text-yellow-600 mb-1">
                      20+
                    </div>
                    <div className="text-xs text-gray-600">Courses</div>
                  </div>
                  <div className="bg-gradient-to-br from-red-50 to-pink-50 rounded-xl p-4 text-center">
                    <div className="text-3xl font-bold text-red-600 mb-1">
                      ∞
                    </div>
                    <div className="text-xs text-gray-600">Opportunities</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  };

  const Vision2029 = () => {
    return (
      <section className="py-24 bg-gradient-to-tr from-[#171735] to-[#3c3f8c] text-white scroll-reveal opacity-0 relative overflow-hidden">
        {/* Animated stars background */}
        <div className="absolute inset-0">
          {[...Array(50)].map((_, i) => (
            <div
              key={i}
              className="absolute w-1 h-1 bg-white rounded-full animate-twinkle"
              style={{
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 5}s`,
                animationDuration: `${3 + Math.random() * 5}s`,
              }}
            />
          ))}
        </div>

        <div className="container-iblotec relative z-10">
          <div className="text-center mb-16">
            <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-white/40 to-white text-black px-6 py-2 rounded-full text-sm font-semibold mb-6">
              <i className="fa-solid fa-eye text-[#3c3f8c]"></i>
              <span className="text-[#3c3f8c]">IBloTec 2029 Vision</span>
            </div>
            <h2 className="text-5xl md:text-7xl font-black mb-6">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00a6d8]  via-amber-100 to-[#00a6d8] ">
                Where We're Headed
              </span>
            </h2>
            <p className="text-xl text-white/80 max-w-3xl mx-auto">
              Since 2021, we've never stopped dreaming. Despite challenges, we
              keep building Africa's digital future.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {[
              {
                icon: "fa-solid fa-microchip",
                title: "Africa Tech Tycoon",
                desc: "Leading Africa's digital transformation with innovative solutions",
                color: "from-cyan-400 to-blue-500",
              },
              {
                icon: "fa-solid fa-trophy",
                title: "Market Dominance",
                desc: "Setting the standard for AfroCommerce across the continent",
                color: "from-yellow-400 to-amber-500",
              },
              {
                icon: "fa-solid fa-hand-holding-heart",
                title: "Service Humanity",
                desc: "Using technology to improve lives and create opportunities",
                color: "from-pink-400 to-rose-500",
              },
              {
                icon: "fa-solid fa-briefcase",
                title: "5,000+ Workforce",
                desc: "Creating meaningful employment across Africa and beyond",
                color: "from-green-400 to-emerald-500",
              },
              {
                icon: "fa-solid fa-users",
                title: "Millions of Users",
                desc: "Connecting Africa and the diaspora on a global scale",
                color: "from-purple-400 to-indigo-500",
              },
              {
                icon: "fa-solid fa-chart-line",
                title: "Continental Leader",
                desc: "Shaping policies and innovations for African tech ecosystem",
                color: "from-red-400 to-orange-500",
              },
            ].map((item, index) => (
              <div key={index} className="group relative">
                <div
                  className={`absolute inset-0 bg-gradient-to-r ${item.color} rounded-3xl blur-xl opacity-0 group-hover:opacity-30 transition-opacity duration-500`}
                ></div>
                <div className="relative bg-white/5 backdrop-blur-lg rounded-3xl p-8 border border-white/10 hover:border-white/30 transition-all duration-500 hover:scale-105 hover:bg-white/10">
                  <div
                    className={`w-16 h-16 bg-gradient-to-r ${item.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-12 transition-all duration-500`}
                  >
                    <i className={`${item.icon} text-white text-2xl`}></i>
                  </div>
                  <h3 className="text-xl font-bold mb-3 text-white">
                    {item.title}
                  </h3>
                  <p className="text-white/70 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Timeline Achievement */}
          <div className="relative">
            <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-[#00a6d8] to-[#3c3f8c] hidden md:block"></div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              <div className="relative md:text-right">
                <div className="bg-white/5 backdrop-blur-lg rounded-3xl p-8 border border-white/10 hover:border-[#00a6d8]/30 transition-all duration-500">
                  <div className="absolute -right-4 top-1/2 transform -translate-y-1/2 w-8 h-8 bg-[#00a6d8] rounded-full hidden md:flex items-center justify-center">
                    <div className="w-3 h-3 bg-white rounded-full animate-ping"></div>
                  </div>
                  <h4 className="text-2xl font-bold text-[#00a6d8] mb-2">
                    2021
                  </h4>
                  <p className="text-white/80">
                    IBloTec founded — A dream to transform Africa through
                    technology
                  </p>
                </div>
              </div>

              <div className="relative md:col-start-2">
                <div className="bg-white/5 backdrop-blur-lg rounded-3xl p-8 border border-white/10 hover:border-[#3c3f8c]/30 transition-all duration-500">
                  <div className="absolute -left-4 top-1/2 transform -translate-y-1/2 w-8 h-8 bg-[#3c3f8c] rounded-full hidden md:flex items-center justify-center">
                    <div className="w-3 h-3 bg-white rounded-full animate-ping"></div>
                  </div>
                  <h4 className="text-2xl font-bold text-[#3c3f8c] mb-2">
                    2023
                  </h4>
                  <p className="text-white/80">
                    IBloTec Market launch — Connecting African sellers to the
                    world
                  </p>
                </div>
              </div>

              <div className="relative">
                <div className="bg-white/5 backdrop-blur-lg rounded-3xl p-8 border border-white/10 hover:border-[#00a6d8]/30 transition-all duration-500">
                  <div className="absolute -right-4 top-1/2 transform -translate-y-1/2 w-8 h-8 bg-[#00a6d8] rounded-full hidden md:flex items-center justify-center">
                    <div className="w-3 h-3 bg-white rounded-full animate-ping"></div>
                  </div>
                  <h4 className="text-2xl font-bold text-[#00a6d8] mb-2">
                    2025
                  </h4>
                  <p className="text-white/80">
                    IBloCash & IBloPay — Building Africa's payment
                    infrastructure
                  </p>
                </div>
              </div>

              <div className="relative">
                <div className="bg-white/5 backdrop-blur-lg rounded-3xl p-8 border border-white/10 hover:border-[#3c3f8c]/30 transition-all duration-500">
                  <div className="absolute -left-4 top-1/2 transform -translate-y-1/2 w-8 h-8 bg-[#3c3f8c] rounded-full hidden md:flex items-center justify-center">
                    <div className="w-3 h-3 bg-white rounded-full animate-ping"></div>
                  </div>
                  <h4 className="text-2xl font-bold text-[#3c3f8c] mb-2">
                    2029
                  </h4>
                  <p className="text-white/80">
                    Africa's leading tech ecosystem — 5,000+ workforce, millions
                    of users
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  };

  // Add this CSS to your home.css file:
  /*
@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
}
@keyframes bounce-subtle {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
}
@keyframes pulse-slow {
  0%, 100% { opacity: 0.3; }
  50% { opacity: 0.6; }
}
@keyframes twinkle {
  0%, 100% { opacity: 0.2; transform: scale(0.8); }
  50% { opacity: 1; transform: scale(1.2); }
}
.animate-float { animation: float 6s ease-in-out infinite; }
.animate-bounce-subtle { animation: bounce-subtle 2s ease-in-out infinite; }
.animate-pulse-slow { animation: pulse-slow 4s ease-in-out infinite; }
.animate-twinkle { animation: twinkle 4s ease-in-out infinite; }
*/

  // Then add these components inside your return statement, between existing sections:

  return (
    <>
      <Navbar />
      {/* IBloDescription Section */}
      <TypingText />

      {/* About IBloTec Section */}
      <section className="py-10 md:py-24 bg-white scroll-reveal opacity-0 relative overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 opacity-10">
          <img
            src="images/market1.jpg"
            alt="Background"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="container-iblotec relative z-10">
          <div className="text-center mb-16">
            <div className="inline-flex items-center space-x-2 bg-[#00a6d8] text-white px-6 py-2 rounded-full text-sm font-semibold mb-6">
              <i className="fa-solid fa-star text-white"></i>
              <span className="text-white">About IBloTec</span>
            </div>
            <h2 className="text-4xl md:text-6xl font-black mb-6">
              <span className="text-[#3c3f8c]">Building Africa's</span>
              <br />
              <span className="text-[#00a6d8]">Digital Future</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="space-y-8">
              <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-[#00a6d8]/20">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#00a6d8] rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="fa-solid fa-lightbulb text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#3c3f8c] mb-3">
                      Our Vision
                    </h3>
                    <p className="text-gray-700 leading-relaxed">
                      <strong>IBloTec</strong> is a visionary African tech
                      company committed to building a complete digital ecosystem
                      that connects people, products, and innovation across
                      Africa and the diaspora.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-[#00a6d8]/20">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#3c3f8c] rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="fa-solid fa-rocket text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#3c3f8c] mb-3">
                      Our Mission
                    </h3>
                    <p className="text-gray-700 leading-relaxed">
                      Founded in 2021, IBloTec stands for{" "}
                      <span className="font-semibold text-[#00a6d8]">
                        Innovation, Blockchain, and Technology
                      </span>{" "}
                      — driving financial inclusion, empowering local
                      businesses, and shaping Africa's future through
                      technology.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-[#00a6d8]/20">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#00a6d8] rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="fa-solid fa-users text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#3c3f8c] mb-3">
                      By Africans, For Africans
                    </h3>
                    <p className="text-gray-700 leading-relaxed">
                      From <strong>IBloTec Market</strong> to upcoming
                      innovations like <em>IBlox</em>, <em>IBloCash</em>,{" "}
                      <em>IBloChat</em>, and <em>IBloTec Academy</em>, we create
                      tools made by Africans, for Africans.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="relative z-10">
                <img
                  src="images/market1.jpg"
                  alt="IBloTec Vision"
                  className="rounded-3xl shadow-2xl w-full"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent rounded-3xl"></div>
                <div className="absolute bottom-8 left-8 text-white">
                  <h4 className="text-2xl font-bold mb-2 text-white">
                    2025 - Present
                  </h4>
                  <p className="text-lg opacity-90 text-white">
                    Building Africa's Digital Ecosystem
                  </p>
                </div>
              </div>

              {/* Floating Stats */}
              <div className="absolute -top-6 -right-6 bg-white rounded-2xl p-6 shadow-xl border border-[#00a6d8]/20 z-10">
                <div className="text-center">
                  <div className="text-3xl font-bold text-[#00a6d8]">1000+</div>
                  <div className="text-sm text-[#3c3f8c]">Active Users</div>
                </div>
              </div>

              <div className="absolute -bottom-20 -left-6 bg-white rounded-2xl p-6 shadow-xl border border-[#00a6d8]/20 z-10">
                <div className="text-center">
                  <div className="text-3xl font-bold text-[#3c3f8c]">3+</div>
                  <div className="text-sm text-[#3c3f8c]">
                    Countries Reached
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Add Ecosystem Section */}
      <EcosystemSection />

      {/* IBloTec Market Section */}
      <section className="py-24 bg-gradient-to-br from-[#3c3f8c]/80 to-[#00a6d8]/80 text-white scroll-reveal opacity-0 relative overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 opacity-20">
          <img
            src="images/market1.jpg"
            alt="Background"
            className="w-full h-full object-cover"
          />
        </div>
        {/* Animated Background */}
        <div className="absolute inset-0">
          <div className="absolute top-10 left-10 w-72 h-72 bg-[#00a6d8]/50 rounded-full blur-3xl animate-pulse"></div>
          <div
            className="absolute bottom-10 right-10 w-96 h-96 bg-white/10 rounded-full blur-3xl animate-pulse"
            style={{ animationDelay: "1s" }}
          ></div>
        </div>

        <div className="container-iblotec relative z-10">
          <div className="text-center mb-16">
            <div className="inline-flex items-center space-x-2 bg-[#00a6d8] text-white px-6 py-2 rounded-full text-sm font-semibold mb-6">
              <i className="fa-solid fa-store text-white"></i>
              <span className="text-white">Our Flagship Platform</span>
            </div>
            <h2 className="text-5xl md:text-7xl font-black mb-6">
              <span className="text-white">IBloTec Market</span>
            </h2>
            <p className="text-xl md:text-2xl text-white max-w-3xl mx-auto leading-relaxed">
              Powering African Commerce • Connecting Continents • Building
              Dreams
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
            {/* Feature Cards */}
            <div className="group">
              <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20 hover:bg-white/20 transition-all duration-500 hover:scale-105">
                <div className="w-16 h-16 bg-[#00a6d8]/60 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className="fa-solid fa-globe-africa text-white text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4 text-[#c7f2ff]">
                  Digital Inclusion
                </h3>
                <p className="text-white leading-relaxed">
                  Giving even small, rural vendors access to e-commerce and
                  global markets through innovative technology.
                </p>
              </div>
            </div>

            <div className="group">
              <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20 hover:bg-white/20 transition-all duration-500 hover:scale-105">
                <div className="w-16 h-16 bg-[#3c3f8c]/70 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className="fa-solid fa-heart text-white text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4 text-[#cdceff]">
                  Afro-centric Trade
                </h3>
                <p className="text-white leading-relaxed">
                  Promoting "Made in Africa" products with pride, celebrating
                  our heritage and craftsmanship.
                </p>
              </div>
            </div>

            <div className="group">
              <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20 hover:bg-white/20 transition-all duration-500 hover:scale-105">
                <div className="w-16 h-16 bg-[#00a6d8]/50 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className="fa-solid fa-briefcase text-white text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4 text-[#c7f2ff]">
                  Opportunity Creation
                </h3>
                <p className="text-white leading-relaxed">
                  Creating jobs for agents, delivery workers, and digital
                  marketers across the continent.
                </p>
              </div>
            </div>
          </div>

          {/* Call to Action */}
          <div className="text-center">
            <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-12 border border-white/20 max-w-4xl mx-auto">
              <h3 className="text-2 xl md:text-4xl font-bold mb-6 text-white">
                Ready to Transform African Commerce?
              </h3>
              <p className="text-xl text-white mb-8 max-w-2xl mx-auto">
                Join thousands of entrepreneurs who are already building their
                digital future with IBloTec Market.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link
                  to="/https://iblotecmarket.com/"
                  className="group bg-[#00a6d8] hover:bg-[#3c3f8c] text-white px-10 py-4 rounded-full font-bold text-lg transition-all duration-300 hover:scale-105 hover:shadow-2xl flex items-center justify-center space-x-3"
                >
                  <span className="text-white">Start Shopping</span>
                  <i className="fa-solid fa-shopping-cart group-hover:bounce text-white"></i>
                </Link>
                <Link
                  to="https://iblotecmarket.com/vendor/auth/registration/index"
                  className="border-2 border-white text-white px-10 py-4 rounded-full font-bold text-lg bg-white/70 backdrop-blur-sm hover:bg-white transition-all duration-300 flex items-center justify-center space-x-3 hover:scale-105 hover:shadow-2xl"
                >
                  <span className="text-[#00a6d8]">Become a Seller</span>
                  <i className="fa-solid fa-store text-[#00a6d8]"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Add Achievements Showcase - Place this before or after your Problem/Solution section */}
      <section className="py-16 bg-gradient-to-br from-white to-gray-50">
        <div className="container-iblotec">
          <AchievementsShowcase />
        </div>
      </section>

      {/* Add Vision 2029 Section - This is NEW */}
      <Vision2029 />

      {/* Keep all your existing sections */}
      <ProductSlider />
      {/* ... rest of your sections */}

      <Footer />
    </>
  );
}

export default Home;

/*"New content"

IBloTec is a visionary African tech company committed to building a complete digital ecosystem that connects people, products, and innovation across Africa and the diaspora. Founded in 2021, IBloTec stands for *Innovation, Blockchain, and Technology* — and our mission is to drive financial inclusion, empower local businesses, and shape Africa’s future through technology.

From our flagship platform *IBloTec Market* — a marketplace empowering African sellers — to upcoming innovations like *IBlox*, *IBloCash*, *IBloChat*, and *IBloTec Academy*, we are creating tools made *by Africans, for Africans*.

We believe in bold ideas, smart strategies, and lasting impact. With a growing network, strong community, and committed leadership, IBloTec is more than a company — it’s a movement for Africa’s digital.

*IBloTec Market: Powering African Commerce*

*IBloTec Market* is the *flagship platform* of IBloTec — a digital marketplace designed to connect *African products, services, and talents* to both local and global buyers. It’s not just a store — it’s a movement to bring visibility, opportunity, and dignity to African entrepreneurship.

*What IBloTec Market stands for:*

- *Digital Inclusion:* Giving even small, rural vendors access to e-commerce.
- *Afro-centric Trade:* Promoting “Made in Africa” products with pride.
- *Opportunity Creation:* Creating jobs for agents, delivery workers, and digital marketers across the continent.
- *Export Made Easy:* Helping African creators sell beyond borders without complications.

*The Problem We Are Solving:*

- Many African producers can’t access digital tools or global markets.  
- Youth lack platforms to showcase their skills or generate income online.  
- Local products and talents are undervalued and underrepresented.

*IBloTec Market* changes that.

Africa marketplace, built by Africans ,for the world

*/
